module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/torreborre.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/torreborre.jpg
// module id = 607
// module chunks = 0